import styled, { keyframes } from "styled-components";
import { fadeIn } from "react-animations";
import Color from "../../../../assets/styles/colors";

const fadeInLeftAnimation = keyframes`${fadeIn}`;

export const Container = styled.div`
  animation: 2s ${fadeInLeftAnimation};
`;

export const Div = styled.div``;

export const Icon = styled.i`
  color: ${Color.colorAppOrange};
`;

export const Title = styled.span`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? Color.textColorBlackFive
      : Color.textColorBlackOne};
`;

export const HeaderDetailTitle = styled.span`
  font-weight: bold;
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? Color.textColorBlackTow
      : Color.textColorBlackSix};
`;

export const HeaderDetailIcon = styled.i`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? Color.textColorBlackTow
      : Color.textColorBlackOne};
`;
